import {
  YearSelectorButtons,
  YearSelectorContainer,
  YearSelectorTitle,
} from './styles/YearSelector.styled';
import { IIconProps } from '@fluentui/react';
import { EmployeeVacationDays } from '../../../../tabs/models/SummaryInterfaces';
import debounce from 'debounce';

interface YearSelectorProps {
  year: number;
  incrementYear: () => void;
  decrementYear: () => void;
  vacationPeriodNextYear: EmployeeVacationDays;
  vacationPeriodPrevYear: EmployeeVacationDays;
  loadingVacationPeriod: boolean;
}

export const YearSelector = ({
  decrementYear,
  incrementYear,
  year,
  vacationPeriodNextYear,
  loadingVacationPeriod,
  vacationPeriodPrevYear,
}: YearSelectorProps) => {
  const currentYear = new Date().getFullYear();
  const rightChevron: IIconProps = {
    iconName: 'ChevronRightSmall',
  };
  const leftChevron: IIconProps = {
    iconName: 'ChevronLeftSmall',
  };

  const incrementDisabled = !vacationPeriodNextYear && !(year < currentYear);
  const decrementDisabled = !vacationPeriodPrevYear && !(year > currentYear);

  const debouncedIncrement = debounce(incrementYear, 300);
  const deboucedDecrement = debounce(decrementYear, 300);

  return (
    <YearSelectorContainer>
      <YearSelectorButtons
        onClick={() => {
          if (!loadingVacationPeriod) {
            deboucedDecrement();
          }
        }}
        iconProps={leftChevron}
        disabled={decrementDisabled}
      />
      <YearSelectorTitle>{year}</YearSelectorTitle>
      <YearSelectorButtons
        onClick={() => {
          if (!loadingVacationPeriod) {
            debouncedIncrement();
          }
        }}
        iconProps={rightChevron}
        disabled={incrementDisabled}
      />
    </YearSelectorContainer>
  );
};
